import { toneClasses } from "@/lib/tone"
import { CustomerStatus, CustomerType, LocationStatus, SlotService } from "@/types/collections"

export const getStatusColor = (status: CustomerStatus | LocationStatus | string) => {
  switch (status) {
    case "active":
      return toneClasses("success").badge
    case "pending":
    case "pending_verification":
      return toneClasses("warning").badge
    case "suspended":
      return toneClasses("danger").badge
    default:
      return toneClasses("neutral").badge
  }
}

export const getCustomerTypeColor = (type: CustomerType) => {
  switch (type) {
    case "shipper":
      return "bg-blue-100 text-blue-700"
    case "pudo":
      return "bg-purple-100 text-purple-700"
    case "haulage":
      return "bg-emerald-100 text-emerald-700"
    case "internal":
      return "bg-amber-100 text-amber-700"
    case "other":
      return "bg-palette-jungleGreen100 text-palette-jungleGreen700"
    default:
      return "bg-palette-jungleGreen100 text-palette-jungleGreen700"
  }
}

/** Coloured by the first service when given several. */
export const getSlotServiceColor = (service: SlotService | SlotService[]) => {
  const services = Array.isArray(service) ? service : [service]
  if (services.length === 0) return "bg-palette-jungleGreen100 text-palette-jungleGreen700"
  switch (services[0]) {
    case "SD":
      return "bg-blue-100 text-blue-700"
    case "ND":
      return "bg-green-100 text-green-700"
    case "2D":
      return "bg-purple-100 text-purple-700"
    default:
      return "bg-palette-jungleGreen100 text-palette-jungleGreen700"
  }
}
